import React from "react";
import classNames from "classnames/bind";
import s from "./ExploreFeatures.module.scss";
import { getMakeStyleClasses } from "../common/getMakeStyleClasses";
import { EXPLORE_FEATURES } from "../../constants/constants";

const ExploreFeatures = (props) => {
  const classes = getMakeStyleClasses(compClasses);
  const cx = classNames.bind(classes);

  return (
    <section className={cx(s.container)}>
      <section className={cx(s.heading, classes.primaryThemeColor)}>
        {EXPLORE_FEATURES.heading}
      </section>
      <section className={cx(s.contentContainer)}>
        {EXPLORE_FEATURES.features.map((x, index) => {
          return (
            <div key={index} className={s.feature}>
              <span className={cx(s.title, classes.primaryThemeColor)}>
                {x.title}
              </span>
              <span className={cx(classes.secondaryTextColor, s.description)}>
                {x.description}
              </span>
            </div>
          );
        })}
      </section>
    </section>
  );
};

export default ExploreFeatures;

const compClasses = (theme) => ({
  secondaryHeading: {
    color: theme.palette.text.secondary,
  },
});
